import React from 'react';
import { BOTTOM_INDENTS } from '@constants';
import { ACCOUNT_USER_ROLE, ACCOUNT_USER_STATUS } from '@enums';
import { useModal, useStore } from '@hooks';
import { Button, WhiteCover } from '@ui';
import { observer } from 'mobx-react';
import TeamMember from '../TeamMember';
import TransferModal from './components/TransferModal';

const StoreOwner = observer(() => {
    const store = useStore();
    const { storeOwner, staffAccounts } = store.accountsStore;
    const { me } = store.authStore;
    const { close, open } = useModal();

    const openModal = () => {
        open({
            title: 'Transfer ownership',
            content: <TransferModal close={close} />,
            key: 'store-transfer',
            settings: {
                width: '630px'
            }
        });
    };

    const activeMembers = staffAccounts.filter(
        (m) => m.status === ACCOUNT_USER_STATUS.ACTIVE || m.status === ACCOUNT_USER_STATUS.TRANSFER_OWNERSHIP
    );

    return (
        <WhiteCover
            data-e2e='team-management_store-owner_block'
            rightContent={
                activeMembers.length && me.permission?.role === ACCOUNT_USER_ROLE.OWNER ? (
                    <Button
                        type='link'
                        padding='0'
                        onClick={openModal}
                        data-e2e='team-management_transfer-ownership_btn'
                    >
                        Transfer Ownership
                    </Button>
                ) : null
            }
            title='Store owner'
            style={BOTTOM_INDENTS.M}
        >
            <TeamMember member={storeOwner} isOwner />
        </WhiteCover>
    );
});

export default StoreOwner;
